import React from "react";
import { Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const UserInfoComponent = ({
  userProfile,
  editUserInfo,
  firstName,
  handleSetFirstName,
  lastName,
  handleSetLastName,
  handleSendUserData,
  handleEditUserInfo,
}) => {
  const { t } = useTranslation();

  return (
    <Col md={12} lg={6} className={"UserDataContainer"}>
      {userProfile?.email && (
        <>
          {editUserInfo ? (
            <label className="campoForm campoFirstName">
              <h2 className={"Title-bold"}>{t("perfil.firstName")}</h2>
              <input
                className="UserInfoInput"
                type="text"
                placeholder={firstName}
                value={firstName}
                onChange={handleSetFirstName}
              />
            </label>
          ) : (
            <div>
              <h2 className={"Title-bold"}>{t("perfil.email")}</h2>
              <p className={"UserInfoP"}>{userProfile.email}</p>
            </div>
          )}
        </>
      )}
      {userProfile?.firstName && userProfile?.lastName && (
        <>
          {editUserInfo ? (
            <label className="campoForm campoFirstName">
              <h2 className={"Title-bold"}>{t("perfil.lastName")}</h2>
              <input
                className="UserInfoInput"
                type="text"
                placeholder={lastName}
                value={lastName}
                onChange={handleSetLastName}
              />
            </label>
          ) : (
            <div className="UserNameSection">
              <div className="UserNameHeader">
                <h2 className={"Title-bold-firstlastname"}>{t("perfil.firstlastname")}</h2>
                <FontAwesomeIcon 
                  icon={faEdit} 
                  className="Link-datos EditIconInline"
                  onClick={handleEditUserInfo}
                  title={t("ficha.edit")}
                />
              </div>
              <p className={"UserInfoP"}>
                {userProfile.firstName} {userProfile.lastName}
              </p>
            </div>
          )}
        </>
      )}
      {editUserInfo && (
        <div className="EditButtonsContainer">
          <div
            onClick={handleEditUserInfo}
            className={"ProfileOptionButton"}
          >
            <div>
              <ion-icon name="close" aria-label={t("perfil.edit.cancel")} />
            </div>
            <span>{t("perfil.edit.cancel")}</span>
          </div>
          <div
            onClick={handleSendUserData}
            className={
              firstName === userProfile.firstName &&
              lastName === userProfile.lastName
                ? "ProfileOptionButton" + " disabled"
                : "ProfileOptionButton"
            }
          >
            <div>
              <ion-icon name="checkmark" aria-label={t("perfil.edit.validate")} />
            </div>
            <span>{t("perfil.edit.validate")}</span>
          </div>
        </div>
      )}
    </Col>
  );
};

export default UserInfoComponent;
